<template>
  <OmtLayoutHeaderFooter :bg="['none', '#F6F6F9']" :header="{ titleLabel: 'Minhas Informações' }">
    <router-view />
  </OmtLayoutHeaderFooter>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  name: "MyContacts",
  mounted() {
    this.initPage();
  },
  data() {
    return {
      infoModalIsOpen: false
    };
  },
  methods: {
    ...mapActions("saude", ["fetchRoute"]),
    ...mapActions("myContacts", ["validateActiveTicket", "fetchResumeContacts", "initBeneficiaries"]),
    async initPage() {
      try {
        this.$root.$emit("show-loading");
        await this.initBeneficiaries();

        if (this.beneficiaries.length > 0) {
          await this.fetchResumeContacts();
        }

        await this.validateActiveTicket();
      } catch (error) {
        Swal.fire({
          title: "Erro",
          text: error,
          confirmButtonText: "OK",
          icon: "error"
        });
      } finally {
        if (!this.beneficiaries.length) this.$router.push(await this.fetchRoute());
        this.$root.$emit("hide-loading");
      }
    }
  },
  computed: {
    ...mapState({
      beneficiaries: state => state.myContacts.beneficiaries
    })
  }
};
</script>
